import styled from '@mui/system/styled';

interface PillProps {
  text: string;
  circleColor: string;
  textColor: string;
  backgroundColor: string;
}

const Pill = ({ text, circleColor, textColor, backgroundColor }: PillProps) => {
  return (
    <StyledPillContainer
      textColor={textColor}
      backgroundColor={backgroundColor}
      role="status"
      aria-label={text}
    >
      <StyledCircle circleColor={circleColor} />
      <Text textColor={textColor}>{text}</Text>
    </StyledPillContainer>
  );
};

const StyledPillContainer = styled('div')(
  ({
    textColor,
    backgroundColor,
  }: {
    textColor: string;
    backgroundColor: string;
  }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor,
    color: textColor,
    borderRadius: '20px',
    padding: '4px 8px',
    fontSize: '1rem',
    height: '2rem',
  })
);

const StyledCircle = styled('div')(
  ({ circleColor }: { circleColor: string }) => ({
    width: '1rem',
    height: '1rem',
    backgroundColor: circleColor,
    borderRadius: '50%',
    marginRight: '0.5rem',
  })
);

const Text = styled('span')(({ textColor }: { textColor: string }) => ({
  color: textColor,
  fontSize: '1rem',
  fontWeight: 'bold',
}));

export default Pill;
